import { BasicsClass } from '@/common/BasicsClass';

export class SpringFExchangeRecordAPI extends BasicsClass {

  public apiUrls: any = new Map([
    ['list', {
      url: '/admin/newYearActivity/convertRecord',
      name: 'list',
      label: '兑换记录列表'
    }],
    ['export', {
      url: '/admin/newYearActivity/convertRecordExport',
      name: 'export',
      label: '导出'
    }],

    ['delivery', {
      url: '/admin/newYearActivity/convertDelivery',
      name: 'delivery',
      label: '发货'
    }],

  ])
  public getList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {

    params = {
      ...(params || {})
    }

    const apiUrls = this.apiUrls

    const url = apiUrls.get('list').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  public exportList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('export').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  public delivery(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('delivery').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

}
